module.exports = __webpack_public_path__ + "static/media/get_github_info.0692ddac.webp";